function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFreshcoinsLogoVar04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 424.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M96.11,303.88c2.61-6.13,22.29-52.08,35.39-73.92l-6.88,4.47,7.99-17.3,22.1-50.71c4.04-9.26,13.19-15.23,23.3-15.23,4.55,0,8.93,1.2,12.77,3.46l8.67-12.38c15.99-22.81,42.16-36.43,70-36.43,2.32,0,4.67,.1,6.99,.29l16.82,1.37h4.91l.4,5.12,1.38,17.03c2.05,25.05-6.97,49.62-24.73,67.4l-.03,.03c-3.52,3.52-7.35,6.73-11.38,9.56l-12.4,8.68c3.06,5.22,4.18,11.44,3.03,17.53-1.56,8.25-7.09,15.18-14.79,18.53l-67.59,29.46,4.54-6.98c-2.08,1.03-4.43,2.05-7.06,3.09l-23.73,11.24c-19.64,10.09-41.7,22.53-41.92,22.66l-14.14,7.98,6.36-14.94Z",
    style: {
      fill: "#dabc64"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M164.97,176.57s.06-.06,.09-.09c-.03,.03-.06,.06-.09,.09Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.47,192.39c.09-.14,.19-.28,.28-.42-.05,.08-.1,.15-.15,.23-.04,.06-.08,.13-.12,.19Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.85,167.51s-.09,.06-.14,.09c.05-.03,.09-.06,.14-.09Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.23,164.22c-.12,.05-.24,.1-.36,.15,.12-.05,.24-.1,.36-.15Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.99,224.12s.03,.03,.04,.04c0,0,0,0,0,0l2.15-2.15-.04-.04-2.15,2.15Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.08,162.63c1.65-.22,2.83-.17,3.44-.11h0c-.61-.07-1.79-.11-3.43,.11Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.1,184.52s-.01,.02-.02,.03c0,0,.01-.02,.02-.03Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.98,169.48s-.08,.05-.11,.08c.04-.03,.08-.05,.11-.08Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.83,165.28c-.1,.05-.21,.1-.31,.16,.11-.05,.21-.1,.31-.16Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.97,182.19c-.05,.06-.1,.12-.15,.18,.05-.06,.1-.12,.15-.18Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.4,186.76c-.07,.09-.13,.18-.2,.26,.07-.09,.13-.18,.2-.26Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.55,165.93c-.06,.03-.11,.06-.17,.09,.06-.03,.11-.06,.17-.09Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.22,197.51c-.19,.32-.39,.64-.58,.96,.19-.32,.39-.64,.58-.96Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.81,194.95c-.05,.08-.11,.17-.16,.25,.05-.08,.11-.17,.16-.25Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.75,174.79s-.07,.07-.11,.1c.04-.04,.07-.07,.11-.1Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.46,189.47s-.01,.01-.02,.02c0,0,.01-.01,.02-.02Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.07,164.7c-.07,.03-.14,.06-.22,.09,.07-.03,.15-.06,.22-.09Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.64,180.21s-.03,.04-.05,.05c.02-.02,.03-.04,.05-.05Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.94,171.9s-.07,.06-.11,.09c.04-.03,.07-.06,.11-.09Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.36,162.94c-.15,.03-.3,.07-.46,.1,.15-.04,.31-.07,.46-.1Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.54,163.14c-.21,.05-.43,.11-.65,.17,.22-.06,.44-.12,.65-.17Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.9,113.82c-.05,.01-.1,.02-.16,.03,.05-.01,.11-.02,.16-.03Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.87,114.04c-.22,.05-.44,.09-.67,.14,.23-.05,.45-.1,.67-.14Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.08,162.64c-.17,.02-.34,.05-.51,.08,.18-.03,.35-.05,.51-.08Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.44,168.44c-.07,.05-.15,.1-.22,.15,.07-.05,.15-.1,.22-.15Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.42,178.21s-.08,.09-.12,.13c.04-.05,.08-.09,.12-.13Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.23,166.67c-.09,.05-.18,.11-.27,.16,.09-.05,.18-.11,.27-.16Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.47,170.64c-.06,.05-.12,.09-.18,.14,.06-.05,.12-.09,.18-.14Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.35,114.6c.46-.11,.89-.2,1.32-.3-.24,.05-.46,.1-.7,.16-.2,.05-.41,.09-.61,.14Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.54,162.72c-.3,.05-.61,.11-.94,.18,.33-.07,.64-.13,.94-.18Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.34,173.31s-.09,.08-.13,.12c.04-.04,.09-.08,.13-.12Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.41,163.46c-.13,.04-.27,.08-.4,.13,.13-.04,.27-.09,.4-.13Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.4,163.79c-.14,.05-.28,.1-.42,.15,.14-.05,.28-.1,.42-.15Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.77,226.42s-.06,0-.08,0l-17.54,17.54,11.82-17.48c-7.02,.7-15.78,3.84-24.76,12.82,0,0,6.95-10.41,14.21-16.82,0,0-21.5,8.97-24.77,32.75,0,0,0,0,0-.03-.13-.38-2.17-6.69-.66-13.78l-31.55,59.37,60.95-28.86h.03c6.44-2.53,11.81-5.28,14.64-8.11,9.67-9.67,10.78-24.62,3.39-35.54l-23.23,15.71,17.58-17.58Z",
    style: {
      fill: "#0b182f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.98,241.43c-1.51,7.08,.54,13.4,.66,13.78,0,.02,0,.03,0,.03,3.27-23.78,24.77-32.75,24.77-32.75-7.26,6.41-14.21,16.82-14.21,16.82,8.99-8.99,17.75-12.12,24.76-12.82l3.9-5.76c-10.91-7.36-25.85-6.22-35.51,3.43-10.96,10.96-41.16,81.95-41.16,81.95,0,0,47.65-26.9,66.18-34.16l-60.95,28.86,31.55-59.37Z",
    style: {
      fill: "#dabc64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.99,224.12l-2.3,2.3s.06,0,.08,0l2.26-2.26s0,0,0,0c-.01-.01-.03-.03-.04-.04Z",
    style: {
      fill: "#dabc64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.44,124.97l-.47-.47,2.88-2.88,1.27,1.27c13.28-7.05,28.5-10.34,44-9.07l7.83,.64c.25-.06,.47-.1,.7-.16,.18-.04,.36-.08,.54-.12,.23-.05,.45-.1,.67-.14,.3-.06,.59-.13,.87-.18,.05-.01,.11-.02,.16-.03,2.43-.49,3.91-.71,4.14-.75l-17.05-1.39c-28.31-2.32-55.72,10.56-72.02,33.82l-11.97,17.09h0l-27.69,39.54,2.13,2.13,39.66-56.63c6.54-9.33,14.88-16.99,24.34-22.67Z",
    style: {
      fill: "#0b182f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.97,134.49l-9.52-9.52c-9.46,5.68-17.79,13.34-24.34,22.67l-39.66,56.63,11.44,11.44,19.38-34.6c10.54-18.82,25.22-34.73,42.7-46.61Z",
    style: {
      fill: "#dabc64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.13,113.82c-15.5-1.27-30.72,2.02-44,9.07l9.32,9.32c12.75-8.11,26.88-14.12,41.9-17.61,.2-.05,.41-.09,.61-.14l-7.83-.64Z",
    style: {
      fill: "#dabc64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.08,113.11v-.03h-.03l.03,.03Z",
    style: {
      fill: "#0b182f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.9,113.82c-.05,.01-.1,.02-.16,.03-.27,.06-.57,.12-.87,.18-.22,.05-.44,.09-.67,.14-.17,.04-.36,.08-.54,.12-.42,.09-.85,.19-1.32,.3-15.02,3.49-29.15,9.5-41.9,17.61l4.78,4.78-2.88,2.88-5.38-5.38c-17.48,11.88-32.16,27.79-42.7,46.61l-19.38,34.6,2.01,2.01,18.3-27.06c4.37-6.47,13.34-7.58,19.17-2.62l.04-.04c.13,.13,.23,.27,.36,.4,.13,.12,.27,.23,.4,.36l-.04,.04c4.96,5.83,3.85,14.79-2.62,19.17l-27.06,18.3,15.59,15.59,27.5-19.26,12.03-8.43h0s0,0,0,0l17.09-11.97c3.85-2.69,7.39-5.69,10.65-8.94l.02-.02c16.44-16.44,25.08-39.44,23.15-63.07l-1.39-17.05-.03-.03h0c-.23,.04-1.7,.25-4.14,.75Z",
    style: {
      fill: "#0b182f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.19 222.01 186 220.15 184.14 221.96 184.19 222.01",
    style: {
      fill: "#0b182f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.21,114.18c-.18,.04-.36,.08-.54,.12,.18-.04,.37-.08,.54-.12Z",
    style: {
      fill: "#0b182f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.05,113.08c-.24,.04-1.71,.25-4.14,.75,2.44-.49,3.91-.71,4.14-.75Z",
    style: {
      fill: "#0b182f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.75,113.85c-.28,.06-.57,.12-.87,.18,.3-.06,.6-.13,.87-.18Z",
    style: {
      fill: "#0b182f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.86,121.62l-2.88,2.88,.47,.47c1.21-.73,2.44-1.42,3.69-2.08l-1.27-1.27Z",
    style: {
      fill: "#0b182f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.44,124.97l9.52,9.52c1.15-.78,2.31-1.54,3.48-2.28l-9.32-9.32c-1.25,.66-2.48,1.35-3.69,2.08Z",
    style: {
      fill: "#0b182f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.35,139.87l2.88-2.88-4.78-4.78c-1.17,.74-2.33,1.5-3.48,2.28l5.38,5.38Z",
    style: {
      fill: "#0b182f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.14,221.96l-4.25-4.25-2.03,3.01c1.45,.98,2.84,2.11,4.13,3.39l2.15-2.15Z",
    style: {
      fill: "#dabc64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.97,226.48l-11.82,17.48,17.54-17.54c-1.73-.13-3.65-.14-5.73,.07Z",
    style: {
      fill: "#dabc64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.69,226.42l2.3-2.3c-1.29-1.28-2.67-2.41-4.13-3.39l-3.9,5.76c2.08-.21,4-.2,5.73-.07Z",
    style: {
      fill: "#dabc64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186,220.15l31.36-32.11c-5.83-4.96-14.79-3.85-19.17,2.62l-18.3,27.06,4.25,4.25,1.86-1.81Z",
    style: {
      fill: "#dabc64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.16,188.75c-.13-.13-.27-.23-.4-.36,.12,.13,.24,.26,.35,.4l.04-.04Z",
    style: {
      fill: "#dabc64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.03,224.16c.96,.96,1.84,1.97,2.63,3.03,.27,.36,.5,.74,.75,1.1l3.02-2.04-4.25-4.25-2.15,2.15Z",
    style: {
      fill: "#0b182f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.77,226.42l-17.58,17.58,23.23-15.71c-.25-.37-.48-.74-.75-1.1-1.36-.33-3.02-.62-4.89-.77Z",
    style: {
      fill: "#0b182f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.67,227.19c-.79-1.06-1.67-2.07-2.63-3.03l-2.26,2.26c1.87,.15,3.53,.44,4.89,.77Z",
    style: {
      fill: "#0b182f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.4,187.99l-.04,.04c.13,.11,.27,.23,.4,.35-.12-.13-.23-.27-.36-.4Z",
    style: {
      fill: "#0b182f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.11,188.79l-32.11,31.36-1.81,1.86,4.25,4.25,27.06-18.3c6.47-4.37,7.58-13.34,2.62-19.17Z",
    style: {
      fill: "#0b182f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.11,188.79c-.11-.13-.23-.27-.35-.4-.13-.12-.26-.24-.4-.35l-31.36,32.11,32.11-31.36Z",
    style: {
      fill: "#0b182f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.52,162.52h0c-.61-.06-1.78-.12-3.44,.11,0,0,0,0,0,0-.17,.02-.34,.05-.51,.08,0,0-.02,0-.03,0-.3,.05-.61,.11-.94,.18-.08,.02-.16,.03-.24,.05-.15,.03-.3,.07-.46,.1-.12,.03-.24,.06-.36,.09-.21,.05-.43,.11-.65,.17-.16,.05-.32,.09-.49,.14-.13,.04-.27,.08-.4,.13-.2,.06-.4,.13-.61,.2-.14,.05-.28,.1-.42,.15-.25,.09-.49,.18-.75,.28-.12,.05-.24,.1-.36,.15-.26,.11-.53,.22-.79,.34-.07,.03-.14,.06-.22,.09-.33,.15-.68,.31-1.02,.48-.1,.05-.21,.1-.31,.16-.32,.16-.64,.32-.96,.5-.06,.03-.11,.06-.17,.09-.38,.21-.77,.42-1.16,.65-.09,.05-.18,.11-.27,.16-.36,.22-.73,.44-1.1,.68-.05,.03-.09,.06-.14,.09-.42,.27-.85,.55-1.28,.85-.07,.05-.15,.1-.22,.15-.41,.28-.82,.58-1.24,.89-.04,.03-.08,.05-.11,.08-.46,.34-.93,.7-1.4,1.08-.06,.05-.12,.09-.18,.14-.45,.36-.9,.73-1.35,1.11-.04,.03-.07,.06-.11,.09-.49,.42-.99,.86-1.5,1.32-.04,.04-.09,.08-.13,.12-.48,.44-.97,.89-1.46,1.37-.04,.04-.07,.07-.11,.1-.52,.51-1.05,1.04-1.59,1.58-.03,.03-.06,.06-.09,.09-.51,.53-1.03,1.07-1.55,1.64-.04,.05-.08,.09-.12,.13-.55,.6-1.1,1.22-1.66,1.86-.02,.02-.03,.04-.05,.05-.54,.62-1.08,1.27-1.63,1.93-.05,.06-.1,.12-.15,.18-.57,.69-1.14,1.41-1.72,2.15,0,0-.01,.02-.02,.03-.55,.71-1.11,1.46-1.68,2.22-.07,.09-.13,.18-.2,.26-.58,.79-1.16,1.6-1.75,2.44,0,0-.01,.01-.02,.02-.56,.8-1.13,1.63-1.69,2.48-.09,.14-.19,.28-.28,.42-.55,.83-1.1,1.68-1.66,2.56-.05,.08-.11,.17-.16,.25-.47,.75-.95,1.52-1.43,2.3-.19,.32-.39,.64-.58,.96-.39,.64-.77,1.3-1.16,1.96-.16,.28-.33,.56-.49,.84-.51,.89-1.02,1.8-1.54,2.73-.19,.34-.38,.7-.57,1.04-.39,.71-.78,1.43-1.17,2.17-.17,.33-.35,.65-.52,.99-.54,1.03-1.08,2.08-1.62,3.15-.12,.24-.24,.49-.37,.74-.46,.91-.91,1.84-1.37,2.79-.16,.32-.31,.64-.47,.97-.57,1.19-1.14,2.39-1.71,3.63l26.67-17.33,27.69-39.54s-.17-.03-.49-.07Z",
    style: {
      fill: "#0b182f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192.01 162.59 164.31 202.13 192.01 162.59 192.01 162.59",
    style: {
      fill: "#0b182f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.03,241.85l-17.33,26.66,50.76-22.12c12.83-5.59,16-22.34,6.11-32.23l-12.03,8.43-27.5,19.27Z",
    style: {
      fill: "#0b182f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "243.56 214.15 231.53 222.58 243.56 214.15 243.56 214.15 243.56 214.15",
    style: {
      fill: "#0b182f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.83,214.86c.46-.95,.92-1.87,1.37-2.79,.12-.24,.24-.49,.37-.74,.54-1.07,1.08-2.12,1.62-3.15,.17-.33,.35-.66,.52-.99,.39-.73,.78-1.46,1.17-2.17,.19-.35,.38-.7,.57-1.04,.51-.93,1.03-1.84,1.54-2.73,.16-.29,.33-.56,.49-.84,.39-.67,.77-1.32,1.16-1.96,.19-.32,.39-.64,.58-.96,.48-.78,.95-1.55,1.43-2.3,.05-.08,.11-.17,.16-.25,.56-.88,1.11-1.72,1.66-2.56,.04-.06,.08-.13,.12-.19l9.31-21.37c5.13-11.75,19.61-15.4,29.61-8.31h0c.32,.04,.49,.08,.49,.08h0c-9.89-9.89-26.64-6.72-32.24,6.11l-22.12,50.76c.57-1.24,1.14-2.44,1.71-3.63,.16-.33,.31-.65,.47-.97Z",
    style: {
      fill: "#0b182f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.52,162.52h0c.32,.03,.49,.07,.49,.07h0s-.17-.04-.49-.07Z",
    style: {
      fill: "#0b182f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.64,198.47c-.39,.64-.77,1.3-1.16,1.96,.39-.67,.77-1.32,1.16-1.96Z",
    style: {
      fill: "#0b182f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.65,195.2c-.47,.75-.95,1.52-1.43,2.3,.48-.78,.95-1.56,1.43-2.3Z",
    style: {
      fill: "#0b182f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.47,192.39c-.55,.83-1.1,1.68-1.66,2.56,.56-.88,1.11-1.73,1.66-2.56Z",
    style: {
      fill: "#0b182f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.51,162.52c-10-7.08-24.48-3.44-29.61,8.31l-9.31,21.37c.05-.08,.1-.15,.15-.23,.57-.85,1.13-1.68,1.69-2.48,0,0,.01-.01,.02-.02,.59-.84,1.17-1.65,1.75-2.44,.07-.09,.13-.18,.2-.26,.56-.76,1.12-1.5,1.68-2.22,0,0,.01-.02,.02-.03,.58-.74,1.15-1.46,1.72-2.15,.05-.06,.1-.12,.15-.18,.55-.66,1.09-1.31,1.63-1.93,.02-.02,.03-.04,.05-.05,.56-.64,1.11-1.26,1.66-1.86,.04-.05,.08-.09,.12-.13,.52-.57,1.04-1.11,1.55-1.64,.03-.03,.06-.06,.09-.09,.53-.55,1.06-1.08,1.59-1.58,.04-.04,.07-.07,.11-.1,.49-.47,.98-.93,1.46-1.37,.04-.04,.09-.08,.13-.12,.5-.46,1-.9,1.5-1.32,.04-.03,.07-.06,.11-.09,.46-.39,.91-.76,1.35-1.11,.06-.05,.12-.09,.18-.14,.47-.37,.94-.73,1.4-1.08,.04-.03,.08-.05,.11-.08,.42-.31,.83-.6,1.24-.89,.07-.05,.15-.1,.22-.15,.43-.3,.86-.58,1.28-.85,.05-.03,.09-.06,.14-.09,.37-.24,.74-.46,1.1-.68,.09-.05,.18-.11,.27-.16,.39-.23,.78-.45,1.16-.65,.06-.03,.11-.06,.17-.09,.33-.17,.65-.34,.96-.5,.11-.05,.21-.1,.31-.16,.35-.17,.69-.33,1.02-.48,.07-.03,.14-.06,.22-.09,.27-.12,.53-.23,.79-.34,.12-.05,.24-.1,.36-.15,.25-.1,.5-.19,.75-.28,.14-.05,.28-.1,.42-.15,.21-.07,.41-.14,.61-.2,.14-.04,.27-.09,.4-.13,.17-.05,.33-.1,.49-.14,.22-.06,.44-.12,.65-.17,.12-.03,.25-.06,.36-.09,.16-.04,.31-.07,.46-.1,.08-.02,.16-.03,.24-.05,.33-.07,.64-.13,.94-.18,0,0,.02,0,.03,0,.18-.03,.35-.05,.51-.08,0,0,0,0,0,0,1.64-.22,2.82-.18,3.43-.12Z",
    style: {
      fill: "#dabc64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.21,168.6c-.41,.28-.82,.58-1.24,.89,.42-.31,.83-.6,1.24-.89Z",
    style: {
      fill: "#dabc64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.96,166.83c-.36,.22-.73,.44-1.1,.68,.37-.24,.74-.46,1.1-.68Z",
    style: {
      fill: "#dabc64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.72,167.59c-.42,.27-.85,.55-1.28,.85,.43-.3,.86-.58,1.28-.85Z",
    style: {
      fill: "#dabc64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.97,163.94c-.25,.09-.49,.18-.75,.28,.25-.1,.5-.19,.75-.28Z",
    style: {
      fill: "#dabc64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.56,162.71s-.02,0-.03,0c0,0,.02,0,.03,0Z",
    style: {
      fill: "#dabc64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.6,162.89c-.08,.02-.16,.03-.24,.05,.08-.02,.16-.03,.24-.05Z",
    style: {
      fill: "#dabc64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.91,163.05c-.12,.03-.24,.06-.36,.09,.12-.03,.24-.06,.36-.09Z",
    style: {
      fill: "#dabc64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.08,162.63s0,0,0,0c0,0,0,0,0,0Z",
    style: {
      fill: "#dabc64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.39,166.02c-.38,.21-.77,.42-1.16,.65,.39-.23,.78-.45,1.16-.65Z",
    style: {
      fill: "#dabc64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.86,164.36c-.26,.11-.53,.22-.79,.34,.27-.12,.53-.23,.79-.34Z",
    style: {
      fill: "#dabc64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.89,163.31c-.16,.05-.32,.09-.49,.14,.17-.05,.33-.1,.49-.14Z",
    style: {
      fill: "#dabc64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.85,164.8c-.33,.15-.68,.31-1.02,.48,.35-.17,.69-.33,1.02-.48Z",
    style: {
      fill: "#dabc64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,163.58c-.2,.06-.4,.13-.61,.2,.21-.07,.41-.14,.61-.2Z",
    style: {
      fill: "#dabc64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.51,165.43c-.32,.16-.64,.32-.96,.5,.33-.17,.65-.34,.96-.5Z",
    style: {
      fill: "#dabc64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.08,184.55c-.55,.71-1.11,1.46-1.68,2.22,.56-.76,1.12-1.5,1.68-2.22Z",
    style: {
      fill: "#dabc64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.59,180.26c-.54,.62-1.08,1.27-1.63,1.93,.55-.66,1.09-1.31,1.63-1.93Z",
    style: {
      fill: "#dabc64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.21,187.03c-.58,.79-1.16,1.6-1.75,2.44,.59-.84,1.17-1.65,1.75-2.44Z",
    style: {
      fill: "#dabc64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.82,182.37c-.57,.69-1.14,1.41-1.72,2.15,.58-.74,1.15-1.46,1.72-2.15Z",
    style: {
      fill: "#dabc64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.05,176.48c.53-.55,1.06-1.08,1.59-1.58-.52,.51-1.05,1.04-1.59,1.58Z",
    style: {
      fill: "#dabc64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.44,189.49c-.56,.8-1.13,1.63-1.69,2.48,.57-.85,1.13-1.68,1.69-2.48Z",
    style: {
      fill: "#dabc64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.86,169.57c-.46,.34-.93,.7-1.4,1.08,.47-.37,.94-.73,1.4-1.08Z",
    style: {
      fill: "#dabc64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.21,173.43c-.48,.44-.97,.89-1.46,1.37,.49-.47,.98-.93,1.46-1.37Z",
    style: {
      fill: "#dabc64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.83,171.99c-.49,.42-.99,.86-1.5,1.32,.5-.46,1-.9,1.5-1.32Z",
    style: {
      fill: "#dabc64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.29,170.78c-.45,.36-.9,.73-1.35,1.11,.46-.39,.91-.76,1.35-1.11Z",
    style: {
      fill: "#dabc64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.97,176.57c-.51,.53-1.03,1.07-1.55,1.64,.52-.57,1.04-1.11,1.55-1.64Z",
    style: {
      fill: "#dabc64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.3,178.34c-.55,.6-1.1,1.22-1.66,1.86,.56-.64,1.11-1.26,1.66-1.86Z",
    style: {
      fill: "#dabc64"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M346.61,176.04v3.5h16.1v10.95h-15.66v47.09h-13.69v-47.09h-9.64v-10.95h9.64v-3.72c0-12.27,7.34-20.26,20.92-20.26,4.71,0,9.31,.99,12.37,3.18l-3.83,10.29c-2.08-1.42-4.71-2.41-7.56-2.41-5.69,0-8.65,3.18-8.65,9.42Z",
    style: {
      fill: "#0b182f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.5,178.45v13.03c-1.2-.22-2.19-.33-3.18-.33-10.4,0-16.97,6.13-16.97,18.07v28.36h-13.69v-58.48h13.03v8.54c3.94-6.13,11.06-9.2,20.81-9.2Z",
    style: {
      fill: "#0b182f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.32,212.73h-45.89c1.64,8.54,8.76,14.02,18.95,14.02,6.57,0,11.72-2.08,15.88-6.35l7.34,8.43c-5.26,6.24-13.47,9.53-23.54,9.53-19.6,0-32.31-12.59-32.31-30.01s12.81-29.9,30.23-29.9,29.57,11.94,29.57,30.23c0,1.09-.11,2.74-.22,4.05Zm-46-9.09h33.18c-1.1-8.43-7.56-14.24-16.54-14.24s-15.33,5.69-16.65,14.24Z",
    style: {
      fill: "#0b182f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.99,231.78l5.26-10.4c5.15,3.4,13.03,5.8,20.37,5.8,8.65,0,12.27-2.41,12.27-6.46,0-11.17-36.14-.66-36.14-23.98,0-11.06,9.97-18.29,25.74-18.29,7.78,0,16.65,1.86,21.9,5.04l-5.26,10.4c-5.58-3.29-11.17-4.38-16.75-4.38-8.32,0-12.27,2.74-12.27,6.57,0,11.83,36.14,1.31,36.14,24.2,0,10.95-10.08,18.07-26.5,18.07-9.75,0-19.49-2.85-24.75-6.57Z",
    style: {
      fill: "#0b182f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.68,204.08v33.51h-13.69v-31.76c0-10.4-5.15-15.44-13.91-15.44-9.75,0-16.32,5.91-16.32,17.63v29.57h-13.69v-81.26h13.69v29.57c4.49-4.82,11.39-7.45,19.49-7.45,14.02,0,24.42,7.99,24.42,25.63Z",
    style: {
      fill: "#0b182f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.81,208.35c0-17.52,13.14-29.9,31.65-29.9,11.39,0,20.48,4.71,24.97,13.58l-10.51,6.13c-3.5-5.58-8.76-8.1-14.57-8.1-10.08,0-17.74,7.01-17.74,18.29s7.67,18.29,17.74,18.29c5.8,0,11.06-2.52,14.57-8.1l10.51,6.13c-4.49,8.76-13.58,13.69-24.97,13.69-18.51,0-31.65-12.48-31.65-30.01Z",
    style: {
      fill: "#0b182f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.56,208.35c0-17.52,13.14-29.9,31.1-29.9s31.21,12.38,31.21,29.9-13.03,30.01-31.21,30.01-31.1-12.48-31.1-30.01Zm48.51,0c0-11.17-7.45-18.29-17.41-18.29s-17.3,7.12-17.3,18.29,7.45,18.29,17.3,18.29,17.41-7.12,17.41-18.29Z",
    style: {
      fill: "#0b182f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.15,161.26c0-4.6,3.72-8.21,8.76-8.21s8.76,3.4,8.76,7.89c0,4.82-3.61,8.54-8.76,8.54s-8.76-3.61-8.76-8.21Zm1.86,17.85h13.69v58.48h-13.69v-58.48Z",
    style: {
      fill: "#0b182f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M848.26,204.08v33.51h-13.69v-31.76c0-10.4-5.15-15.44-13.91-15.44-9.75,0-16.32,5.91-16.32,17.63v29.57h-13.69v-58.48h13.03v7.56c4.49-5.37,11.61-8.21,20.15-8.21,14.02,0,24.42,7.99,24.42,25.63Z",
    style: {
      fill: "#0b182f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.99,231.78l5.26-10.4c5.15,3.4,13.03,5.8,20.37,5.8,8.65,0,12.27-2.41,12.27-6.46,0-11.17-36.14-.66-36.14-23.98,0-11.06,9.97-18.29,25.74-18.29,7.78,0,16.65,1.86,21.9,5.04l-5.26,10.4c-5.59-3.29-11.17-4.38-16.76-4.38-8.32,0-12.27,2.74-12.27,6.57,0,11.83,36.14,1.31,36.14,24.2,0,10.95-10.08,18.07-26.5,18.07-9.75,0-19.49-2.85-24.75-6.57Z",
    style: {
      fill: "#0b182f"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreshcoinsLogoVar04);
export default __webpack_public_path__ + "static/media/freshcoins_logo_var-04.820a58ef86393aeb689944e13dafc244.svg";
export { ForwardRef as ReactComponent };